import { MENTION_LIST_ID } from "@circle-react-shared/uikit/TipTap/Extensions/CustomExtensions/Mentions/MentionList";
import { EMOJI_LIST_ID } from "@circle-react-shared/uikit/TipTapBlockEditor/InlineEmojiExtension/EmojiPicker";

export const isMentionsOrEmojiPopoverOpen = () =>
  Boolean(document.getElementById(MENTION_LIST_ID)) ||
  Boolean(document.getElementById(EMOJI_LIST_ID));
